import { Type } from '@angular/core';
import { AssistantBlock } from '@/cloud/models/assistant.models';
import { AssistantDeviceCardsComponent } from './device-cards.component';
import { AssistantRoomTilesComponent } from './room-tiles.component';
import { AssistantChartComponent } from './chart-block.component';
import { AssistantLogExcerptComponent } from './log-excerpt.component';
import { AssistantTimelineComponent } from './timeline-block.component';
import { AssistantConfirmActionComponent } from './confirm-action.component';
import { AssistantIssueProposalComponent } from './issue-proposal.component';
import { AssistantIssueCardsComponent } from './issue-cards.component';

/**
 * Which component draws each block type the assistant can send. Adding a block is one component here plus
 * one display tool on the API. Each component takes a single `block` input.
 */
export const ASSISTANT_BLOCKS: Record<AssistantBlock['type'], Type<unknown>> = {
    devices: AssistantDeviceCardsComponent,
    rooms: AssistantRoomTilesComponent,
    chart: AssistantChartComponent,
    logs: AssistantLogExcerptComponent,
    timeline: AssistantTimelineComponent,
    action: AssistantConfirmActionComponent,
    issueProposal: AssistantIssueProposalComponent,
    issues: AssistantIssueCardsComponent
};

export function blockComponent(block: AssistantBlock | null | undefined): Type<unknown> | null {
    return block ? (ASSISTANT_BLOCKS[block.type] ?? null) : null;
}
